import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import { affixRootStyle } from '../../select.vanilla.mjs';
import { useSelectContext, useSelectSearchContext } from '../context.mjs';

const AffixRoot = forwardRef(
  ({ className, ...props }, ref) => {
    const { hasEmptyView } = useSelectContext();
    const { renderEmpty } = useSelectSearchContext();
    const nothingBelow = renderEmpty && !hasEmptyView;
    return /* @__PURE__ */ jsx(
      Legacy_Dropdown.AffixRoot,
      {
        ref,
        className: classNames(
          affixRootStyle({
            bordered: !nothingBelow
          }),
          className
        ),
        ...props
      }
    );
  }
);

export { AffixRoot };
//# sourceMappingURL=AffixRoot.mjs.map
